export default [
    {
        element: '#guide1',
        popover: {
            title: '我的课表',
            description: '老师的教学计划,按上课时间排序.',
            position: 'right',
        }
    },
    {
        element: '#guide2',
        popover: {
            title: '我的班级',
            description: '老师负责的班级',
            position: 'right',
        }
    },
    {
        element: '#guide3',
        popover: {
            title: '作品点评',
            description: '点评学生课堂作品及课后作品',
            position: 'right',
        }
    },
]